import a from './letters/a.mp3';
import ah from './letters/ah.mp3';
import ai from './letters/ai.mp3';
import ar from './letters/ar.mp3';
import b from './letters/b.mp3';
import br from './letters/br.mp3';
import c from './letters/c.mp3';
import ch from './letters/ch.mp3';
import d from './letters/d.mp3';
import e from './letters/e.mp3';
import ea from './letters/ea.mp3';
import er from './letters/er.mp3';
import f from './letters/f.mp3';
import g from './letters/g.mp3';
import h from './letters/h.mp3';
import i from './letters/i.mp3';
import I_cap from './letters/I_cap.mp3';
import ing from './letters/ing.mp3';
import j from './letters/j.mp3';
import k from './letters/k.mp3';
import l from './letters/l.mp3';
import m from './letters/m.mp3';
import n from './letters/n.mp3';
import o from './letters/o.mp3';
import oo from './letters/oo.mp3';
import ou from './letters/ou.mp3';
import p from './letters/p.mp3';
import q from './letters/q.mp3';
import qu from './letters/qu.mp3';
import r from './letters/r.mp3';
import s from './letters/s.mp3';
import sh from './letters/sh.mp3';
import t from './letters/t.mp3';
import th from './letters/th.mp3';
import u from './letters/u.mp3';
import v from './letters/v.mp3';
import w from './letters/w.mp3';
import wh from './letters/wh.mp3';
import x from './letters/x.mp3';
import y from './letters/y.mp3';
import z from './letters/z.mp3';
import ā from './letters/ā.mp3';
import ē from './letters/ē.mp3';
import ō from './letters/ō.mp3';
import ū from './letters/ū.mp3';
import ȳ from './letters/ȳ.mp3';

export const PHONEME_AUDIO_FILES = {
  a,
  b,
  c,
  d,
  e,
  f,
  g,
  h,
  i,
  j,
  k,
  l,
  m,
  n,
  o,
  p,
  q,
  r,
  s,
  t,
  u,
  ū,
  ȳ,
  z,
  ā,
  ē,
  ō,
  y,
  w,
  wh,
  x,
  v,
  th,
  sh,
  qu,
  ou,
  oo,
  ing,
  er,
  ea,
  ch,
  br,
  ar,
  ah,
  ai,
  I_cap,
};
